export const BANNER_STYLES_BY_CONTEXT = {
  body: 'position:fixed;top:0;width:100%;z-index:2000',
  header: 'position:absolute;width:100%;top:100%;z-index:2000',
};
